// Caps the frontend enforces as the user types and the backend enforces on
// the wire. One value each, so the input and the validator never disagree.
/** The largest class size a host can pick (`expectedStudents`). */
export const MAX_EXPECTED_STUDENTS = 1000;
/** The longest self-chosen student name, in UTF-16 code units. */
export const MAX_DISPLAY_NAME_LENGTH = 40;
//# sourceMappingURL=limits.js.map